<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <div>
        <h4 class="earth-color">CHECK OUT TODAY</h4>
        <div class="title-decoration"></div>
      </div>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    v-model="search"
                    class="futuristic-search"></v-text-field>
    </v-card-title>
    <v-data-table :headers="columns"
                  :items="getCheckOutToday"
                  :search="search"
                  :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                  :disable-initial-sort="true"
                  :loading="$loadingTrue"
                  class="futuristic-table">
      <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td data-label="Ref" class="ref-column">
          <router-link :to="{ name: 'Booking', params: { booking_id: props.item.booking_public_id }}">
            <a class="futuristic-link"><u>{{ props.item.booking_ref_code }}</u></a>
            <v-btn v-if="isMobile && (props.item.booking_payment_status !== 'NOT PAID' || props.item.booking_type === 'Partner Booking')"
                   color="#587e27"
                   :depressed="true"
                   small
                   @click="checkOut(props.item.booking_public_id)"
                   class="futuristic-btn">Check Out</v-btn>
          </router-link>
        </td>
        <td data-label="Vehicle Registration">{{ props.item.vehicle_registration }}</td>
        <td data-label="Client Name">{{ props.item.booking_done_by }}</td>
        <td data-label="Entry Pax">{{ props.item.guest_total }}</td>
        <td data-label="Booking Type"><b>{{ props.item.booking_type }}</b></td>
        <td data-label="Payment Status"><b>{{ props.item.booking_payment_status }}</b></td>
        <td data-label="Status" :style="props.item.booking_color">{{ props.item.booking_check_out_status }}</td>
        <td data-label="Action" class="action-column">
          <v-btn v-if="(props.item.booking_payment_status !== 'NOT PAID' || props.item.booking_type === 'Partner Booking')"
                 color="#587e27"
                 :depressed="true"
                 small
                 @click="checkOut(props.item.booking_public_id)"
                 class="futuristic-btn">Check Out</v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
  export default {
    name: 'check-out-today',
    data() {
      return {
        search: '',
        windowWidth: window.innerWidth,
        columns: [
          {
            text: 'Ref',
            value: 'booking_ref_code'
          },
          {
            text: 'Vehicle Registration',
            value: 'vehicle_registration',
          },
          {
            text: 'Client Name',
            value: 'booking_done_by'
          },
          {
            text: 'Entry Pax',
            value: 'guest_total'
          },
          {
            text: 'Booking Type',
            value: 'booking_type'
          },
          {
            text: 'Payment Status',
            value: 'booking_payment_status'
          },
          {
            text: 'Status',
            value: 'booking_status'
          },
          {
            text: 'Action',
            value: ''
          }
        ]
      }
    },
    computed: {
      isMobile() {
        return this.windowWidth <= 800;
      }
    },
    created() {
      this.$store.dispatch('get_check_out_bookings_today');
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      checkOut: function (publicId) {
        var data = {
          booking_id: publicId,
          session_id: localStorage.getItem('lkjhgfdsa')
        }
        this.$store.dispatch('check_out_dash', data)
      },
      handleResize() {
        this.windowWidth = window.innerWidth;
      }
    }
  }
</script>

<style scoped>
  /* Futuristic Card */
  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-card:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  /* Card Header */
  .card-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 12px;
    border-radius: 8px;
  }

  .earth-color {
    color: #587e27;
    font-weight: 600;
    margin: 0;
    font-size: 1.3rem;
  }

  .title-decoration {
    height: 3px;
    background: linear-gradient(90deg, #587e27, transparent);
    margin-bottom: 12px;
    width: 80px;
  }

  /* Input Fields */
  .futuristic-search > > > .v-input__slot {
    border-radius: 6px;
    background: #f5f7fa;
    font-size: 0.9rem;
  }

  /* Buttons */
  .futuristic-btn {
    border-radius: 6px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.2s ease;
    padding: 0 12px;
    height: 28px;
  }

    .futuristic-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    }

  /* Data Table */
  .futuristic-table {
    border-radius: 8px;
    background: #ffffff;
  }

    .futuristic-table > > > th {
      color: #587e27;
      font-weight: 600;
      font-size: 0.9rem;
    }

  /* Links */
  .futuristic-link {
    color: #587e27;
    text-decoration: none;
    transition: color 0.2s ease;
  }

    .futuristic-link:hover {
      color: #1b5e20;
    }

  /* Alerts */
  .futuristic-alert {
    border-radius: 6px;
    background: #fff5f5;
    font-size: 0.85rem;
    padding: 8px;
  }

  /* Responsive Adjustments */
  @media (max-width: 960px) {
    .card-header {
      padding: 10px;
    }

    .earth-color {
      font-size: 1.15rem;
    }

    .futuristic-btn {
      font-size: 0.85rem;
    }
  }

  @media (max-width: 600px) {
    .card-header {
      padding: 8px;
      flex-direction: column;
      align-items: flex-start;
    }

    .earth-color {
      font-size: 1rem;
    }

    .futuristic-btn {
      font-size: 0.8rem;
      height: 24px;
      padding: 0 10px;
    }

    .futuristic-table > > > tr {
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #e0e0e0;
      padding: 6px 0;
      margin: 4px 0;
    }

    .futuristic-table > > > td {
      display: block;
      text-align: left !important;
      padding: 3px 12px;
      font-size: 0.85rem;
    }

      .futuristic-table > > > td:before {
        content: attr(data-label);
        font-weight: bold;
        display: block;
        color: #587e27;
        margin-bottom: 2px;
        font-size: 0.8rem;
      }

    .ref-column {
      order: 1;
    }

    .action-column {
      order: 2;
    }

    .futuristic-search {
      width: 100%;
      margin-top: 8px;
    }

      .futuristic-search > > > .v-input__slot {
        font-size: 0.85rem;
      }
  }
</style>
